export default __webpack_public_path__ + "static/media/Lock.d39d56cf.svg";